import type { MaybeRef } from '@/hooks/usePolicyTypeSelection'
import { unravel } from '@/service/jsonApi'
import { useQuery } from '@tanstack/vue-query'
import { computed, unref } from 'vue'
import {
  getCompanySettings,
  getFastProductEnablement,
} from './companySettingsApi'
import {
  QUERY_KEY_COMPANY_SETTINGS,
  QUERY_KEY_FAST_PRODUCT_ENABLEMENT,
} from './companySettingsKeys'

export const useCompanySettingsQuery = (
  companyNameKey: MaybeRef<string | undefined>
) => {
  return useQuery({
    queryKey: [QUERY_KEY_COMPANY_SETTINGS, companyNameKey],
    queryFn: () => {
      const key = unref(companyNameKey)
      if (key === undefined) {
        throw new Error(
          'useCompanySettingsQuery: companyNameKey is required but was undefined when queryFn ran'
        )
      }
      return getCompanySettings(key)
    },
    select: (data) => unravel(data),
    enabled: computed(() => !!unref(companyNameKey)),
  })
}

export const useFastProductEnablementQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEY_FAST_PRODUCT_ENABLEMENT],
    queryFn: getFastProductEnablement,
    select: ({ data }) =>
      data
        ? Object.entries(data)
            .filter(([, isEnabled]) => isEnabled)
            .map(([product]) => product)
        : [],
  })
}
